console.log('frontend');


// WEBPACK FOOTER //
// blocks/frontend.js